import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";

export default function DetailWrinkleUnderEye({data, img}) {
    return (
        <MeasurementResult type="눈밑 잔주름" description='"눈밑잔주름"은 눈 아래에 형성되는 작은 주름을 가리킵니다. 이 주름은 피부의 탄력이 감소하고 표정의 움직임에 의해 형성될 수 있습니다. 눈밑잔주름은 피부의 탄력을 잃어버리고 수분이 부족할 때 더욱 뚜렷해질 수 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        {
                        img.image_cross_polar_front &&
                        <img src={img.image_cross_polar_front} />
                        }
                        {
                        img.image_mark_under_eye_wrinkle_front &&
                        <img src={img.image_mark_under_eye_wrinkle_front} />
                        }

                        <div className="caption">화이트 라이트</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <DegreeSection 
                    type="눈밑 잔주름"
                    badge={data.analysisBadge}
                    items={[
                    {
                        value: "없음",
                        label: "0"
                    },
                    {
                        value: "경도",
                        label: "1"
                    },
                    {
                        value: "경도",
                        label: "2"
                    },
                    {
                        value: "경도",
                        label: "3"
                    },
                    {
                        value: "중간 정도",
                        label: "4"
                    },
                    {
                        value: "중간 정도",
                        label: "5"
                    },
                    {
                        value: "중간 정도",
                        label: "6"
                    },
                    {
                        value: "중증 정도",
                        label: "7"
                    },
                    {
                        value: "중증 정도",
                        label: "8"
                    },
                ]}
                text={data.degreeText}
                levelFloat={data.levelFloat}
                line={2}
                />
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult}
                />
            </div>
        </MeasurementResult>
    )
}